import { DownloadableMemoriesForm } from "components/Form";
import {
  GlobalLoader,
  ImageElement,
  ModalComponent,
  NoDataFound,
  VideoElement,
  RippleEffect,
} from "components/UiElement";
import { useMemo, useState } from "react";
import { Col, Container, Row, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function DownloadSection({
  memoriesKey,
  setMemoriesKey,
  downloadContentLoader,
  setDownloadData,
  imageVideoData,
  showModal,
  setShowModal,
}) {
  const { t } = useTranslation();
  const [showImageFullModal, setImageFullModal] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [showVideoFullModal, setVideoFullModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");

  const onModalOpen = (type) => {
    setShowModal(type);
    setMemoriesKey(type);
  };

  const onCloseModal = () => {
    setShowModal("");
    setDownloadData([]);
    setMemoriesKey("");
  };

  const modalClasses = useMemo(() => {
    let obj = {
      audio: {
        modalClass: "audioModal",
        titleClass: "audioModal_title",
      },
      "image&video": {
        modalClass: "videoModal",
        titleClass: "videoModal_title",
      },
      file: {
        modalClass: "videoModal pdfModal",
        titleClass: "videoModal_title",
      },
    };
    return obj;
  }, [showModal]);

  // const themesClass = useMemo(() => {
  //   let obj = {
  //     1: {
  //       downloadSec: "downloadSec_inner rounded-0 brd",
  //       storyCardClass: "storyCard storyCard-theme01",
  //     },
  //     2: {
  //       downloadSec: "downloadSec_inner",
  //       storyCardClass: "storyCard",
  //     },
  //     3: {
  //       downloadSec: "downloadSec_inner rounded-0",
  //       storyCardClass: "storyCard storyCard-theme03",
  //     },
  //     4: {
  //       downloadSec: "downloadSec_inner rounded-0",
  //       storyCardClass: "storyCard storyCard-theme04 cursor-pointer",
  //     },
  //   };
  //   return obj;
  // }, [theme]);

  const handleCloseModalVideoFull = (type) => {
    setVideoFullModal(false);
    setShowModal(type);
    setVideoUrl("");
  };
  const handleVideoFullShow = (videoLink) => {
    setVideoFullModal(true);
    setShowModal("");
    setVideoUrl(videoLink);
  };

  const handleCloseModalImageFull = (type) => {
    setImageFullModal(false);
    setShowModal(type);
    setImageUrl("");
  };
  const handleImageFullShow = (imgUrl) => {
    setImageFullModal(true);
    setShowModal("");
    setImageUrl(imgUrl);
  };

  return (
    <>
      <div className="downloadSec">
        <Container>
          <div className="downloadSec_banner position-relative">
            <h2 className="downloadSec_banner_title mb-lg-3 mb-2 text-white">Downloadable Memories</h2>
            <p className="text-white">{t("text.theme.downloadableMemoriesText")}</p>
            <RippleEffect extraClassName="mt-lg-3 mt-sm-1">
                <Button    onClick={() => onModalOpen("image&video")}
                  type="button"
                  className="btn btn-white"
                >
                  Download Memories
                </Button>
              </RippleEffect> 
          </div>
        </Container>
      </div>
      {/* Memories video modal */}
      <ModalComponent
        show={showModal !== ""}
        size="xl"
        title={t("text.theme.downloadableMemories")}
        closeButton="true"
        modalExtraClass={modalClasses?.[showModal]?.modalClass}
        extraTitleClassName={modalClasses?.[showModal]?.titleClass}
        onHandleCancel={() => onCloseModal()}
      >
        {downloadContentLoader ? (
          <GlobalLoader />
        ) : imageVideoData && imageVideoData?.length > 0 ? (
          <DownloadableMemoriesForm
            downloadableData={imageVideoData}
            handleVideoFullShow={(url) => {
              handleVideoFullShow(url, showModal);
            }}
            memoriesKey={memoriesKey}
            handleImageFullShow={handleImageFullShow}
          />
        ) : (
          <NoDataFound />
        )}
      </ModalComponent>
      <ModalComponent
        show={showImageFullModal}
        size="lg"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="videoModal imgFullModal"
        extraTitleClassName="videoModal_title"
        onHandleCancel={() => {
          handleCloseModalImageFull("image&video");
        }}
      >
        <form>
          <div className="videoModal_body">
            <Row className="w-auto">
              <Col sm={12}>
                <div className="position-relative overflow-hidden">
                  <ImageElement
                    previewSource={imageUrl}
                    alt="video"
                    className="img-fluid"
                  />
                </div>
              </Col>
            </Row>
          </div>
        </form>
      </ModalComponent>
      <ModalComponent
        show={showVideoFullModal}
        size="lg"
        title="Downloadable Memories"
        closeButton="true"
        modalExtraClass="videoModal imgFullModal"
        extraTitleClassName="videoModal_title"
        onHandleCancel={() => {
          handleCloseModalVideoFull("image&video");
        }}
      >
        <form>
          <div className="videoModal_body">
            <Row className="w-auto">
              <Col sm={12}>
                <div className="position-relative overflow-hidden">
                  <VideoElement
                    previewSource={videoUrl}
                    alt="video"
                    className="h-auto object-fit-cover"
                    autoPlay
                  />
                </div>
              </Col>
            </Row>
          </div>
        </form>
      </ModalComponent>
    </>
  );
}

export default DownloadSection;
